import {Component, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from "@angular/forms";
import {AppComponent} from "../../../app.component";
import {SharedDataService} from "../../../services/shared-data.service";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {DAY} from "../../../utils/parseUtils";
import {DateAdapter} from "@angular/material/core";
import {ExtendedValidationResult} from "../../../objects/extendedValidationResult";
import {environment} from "../../../../environments/environment";
import {FS3Notification} from "../../../objects/notification";
import {AppEvent} from "../../../objects/appEvent";
import {User} from "../../../objects/user";
import {SubscriptionLike} from "rxjs";

@Component({
  selector: 'app-profile-edit-component',
  templateUrl: './profile-edit-component.component.html',
  styleUrls: ['../mobile-container/mobile-container.component.scss']
})
export class ProfileEditComponentComponent implements OnInit, OnDestroy {

  private sharedEventSubscription: SubscriptionLike;
  private formValidationMessages = {
    required: 'Value required.',
    name_required: AppComponent.getLabel('full_name_required'),
    invalid_field: AppComponent.getLabel('invalid_field'),
    birthday_required: AppComponent.getLabel('required_field'),
    tcs_required: AppComponent.getLabel('ack_tcs_required'),
    privacycheck_required: AppComponent.getLabel('ack_privacy_required'),
  };
  public validationResult: ExtendedValidationResult;
  public componentForm: FormGroup = new FormGroup({});
  public nameInput: FormControl = new FormControl('', [this.formValidator('nameInput')]);
  public phoneInput: FormControl = new FormControl('');
  public birthDayInput: FormControl = new FormControl('', [this.formValidator('birthDayInput')]);
  public tcsCheck: FormControl = new FormControl('', [this.formValidator('tcsCheck')]);
  public privacyCheck: FormControl = new FormControl('', [this.formValidator('privacyCheck')]);
  state: string = 'edit';
  errMsg: string = '';
  activeRequest: boolean = false;
  public birthDate: Date;

  public picture_src_icon: string;
  public picture_src_ava: string;
  public picture_missing: boolean;
  public picture_src_preview: string;
  public aspect_ratio: number;

  constructor(public application: AppComponent,
              private _adapter: DateAdapter<any>,
              private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this._adapter.setLocale('uk');
    this.componentForm.addControl('nameInput', this.nameInput);
    this.componentForm.addControl('phoneInput', this.phoneInput);
    this.componentForm.addControl('birthDayInput', this.birthDayInput);
    this.componentForm.addControl('tcsCheck', this.tcsCheck);
    this.componentForm.addControl('privacyCheck', this.privacyCheck);
    this.phoneInput.disable();

    let fullName = this.application.user.shipping_name + (this.application.user.shipping_surname ? ' '+this.application.user.shipping_surname : '');
    this.nameInput.setValue(fullName);
    this.phoneInput.setValue(this.application.user.shipping_phone);
    let d = new Date(2000, 0, 1);
    if(this.application.user.birthtime) {
      d.setTime(this.application.user.birthtime*1000);
    }
    this.birthDayInput.setValue(d);
    this.privacyCheck.setValue(this.application.user.ack_privacy === 'Y')
    this.tcsCheck.setValue(this.application.user.ack_tcs === 'Y')

    this.picture_src_preview = this.application.user.picture_src_preview;

    this.sharedEventSubscription = this.sharedDataService.globalEventObservable$.subscribe(
      appEvent => {
        if (appEvent.type === AppEvent.SAVE_PROFILE) {
          this.handleSubmit();
        }
        if (appEvent.type === AppEvent.USER_HAS_BEEN_LOGGED) { //go to refreshed user after update
          this.application.router.navigateByUrl('/squash/userview/'+this.application.user.id)
        }
      });
  }
  ngOnDestroy(): void {
    this.sharedEventSubscription.unsubscribe();
  }

  private formValidator(controlKey: string): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
      switch (controlKey) {
        case 'nameInput':
          const nameInputValue = control.value.toString().trim().replace(/\s+/g,' ');
          if (!nameInputValue) {
            return {name_required: this.formValidationMessages.name_required}
          }
          const nameParts = nameInputValue.split(' ')
          if(nameParts.length !== 3) {
            return {invalid_field: this.formValidationMessages.invalid_field}
          }
          break;
        case 'birthDayInput':
          if (!control.value) {
            return {birthday_required: this.formValidationMessages.birthday_required}
          }
          break;
        case 'tcsCheck':
          if (!control.value) {
            return {tcs_required: this.formValidationMessages.tcs_required}
          }
          break;
        case 'privacyCheck':
          if (!control.value) {
            return {privacycheck_required: this.formValidationMessages.privacycheck_required}
          }
          break;
      }

      // if (isNaN(value*1) || parseFloat(value) != parseInt(value)) {
      //   return {onlyDigitsRequired: this.formValidationMessages.onlyDigitsRequired}
      // }
      //
      // if (Math.abs(control.value) > 9999) {
      //   return {maxValueForbidden: this.formValidationMessages.maxValueForbidden}
      // }

      return null;
    };
  }

  public handleSubmit(event: Event | void = null): boolean {
    if(this.activeRequest) return;
    if (event) {
      event.stopPropagation();
    }

    this.validationResult = null;
    let inputsErrors = {};
    //this.componentForm.controls;
    Object.keys(this.componentForm.controls).forEach((inputKey: string) => {
      const abstractControl = this.componentForm.controls[inputKey];
      //console.log('abstractControl',key,abstractControl)
      //abstractControl.markAsDirty();
      if(abstractControl.disabled) return;
      if (!abstractControl.valid) {
        abstractControl.markAsTouched()
        const errorKey = Object.keys(abstractControl.errors)[0]; // get error key from input errors
        inputsErrors[inputKey] = this.formValidationMessages[errorKey]
      }
    });
    if(Object.keys(inputsErrors).length) {
      this.validationResult = {
        isValid: false,
        message: '',
        inputsErrors: inputsErrors
      };
      if(inputsErrors['nameInput']) {
        document.getElementsByClassName('mobile-central-content')[0].scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if(inputsErrors['tcsCheck'] || inputsErrors['privacyCheck']) {
        document.getElementsByClassName('mobile-central-content')[0].scrollTo({
          top: 300, //should be enough
          behavior: "smooth"
        });
      }
      return false;
    }
    if(!this.picture_src_preview) {
      this.picture_missing = true;
      return false;
    }
    this.picture_missing = false;

    // [this.nameInput,this.birthDayInput,this.privacyCheck,this.tcsCheck].forEach(elem => {
    //   if (!elem.valid) {
    //     elem.markAsTouched()
    //     const errorKey = Object.keys(elem.errors)[0]; // get error key from input errors
    //     this.validationResult = {
    //       isValid: false,
    //       message: this.formValidationMessages[errorKey]
    //     };
    //   }
    // });

    this.updateProfile()

    return false;
  }

  public rotateImage(degrees): void {
    //if(this.state == 'loading') return;
    let params = new Object();
    params['gid'] = environment['gid'];
    params['g_hash'] = environment['g_hash'];
    params['url'] = this.picture_src_preview;
    params['degrees'] = degrees;
    this.activeRequest = true;
    this.application.apiService.rotateImage(params).subscribe(
      res => {
        this.activeRequest = false;
        if(res['url']) {
          let params = new Object();
          params['gid'] = environment['gid'];
          params['g_hash'] = environment['g_hash'];
          this.picture_src_ava = params['picture_src_ava'] = res['url'];
          this.picture_src_icon = params['picture_src_icon'] = res['url'];
          this.picture_src_preview = params['picture_src_preview'] = res['url'];
          this.profileUpdateCall(params);
        }
      },
      error => {
        this.activeRequest = false;
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
        let notification = new FS3Notification();
        notification.type = 'error';
        notification.text = errMsg;
        this.sharedDataService.pushNotification(notification);
      }
    );
  }

  private updateProfile() {
    const params = {gid: environment['gid'],g_hash: environment['g_hash']};
    params['full_name'] = this.nameInput.value.trim();
    params['birthtime'] = this.birthDayInput.value.getTime() / 1000 + 3600*12;
    if(this.picture_src_ava) params['picture_src_ava'] = this.picture_src_ava;
    if(this.picture_src_icon) params['picture_src_icon'] = this.picture_src_icon;
    if(this.picture_src_preview) params['picture_src_preview'] = this.picture_src_preview;
    params['ack_tcs'] = this.tcsCheck.value ? 'Y' : 'N';
    params['ack_privacy'] = this.privacyCheck.value ? 'Y' : 'N';
    this.profileUpdateCall(params);
  }

  private profileUpdateCall(params: object) {
    this.activeRequest = true;
    this.application.apiService.updateProfile(params).subscribe(
      res => {
        this.activeRequest = false;
        if(params['full_name']) { //used to skip full update when only picture changed
          let notification = new FS3Notification();
          notification.type = 'success';
          notification.text = AppComponent.getLabel('updated');
          this.sharedDataService.pushNotification(notification);

          //logged user update
          //when complete => navigate to userView by AppEvent.USER_HAS_BEEN_LOGGED listener
          this.application.getCurrentUser();
        }
      },
      error => {
        this.activeRequest = false;
        const { exception } = error;
        const errMsg = error['errMsg'] ? error['errMsg'] : (
          (exception && exception.error && exception.error.message) ? exception.error.message : 'Error'
        );
        let notification = new FS3Notification();
        notification.type = 'error';
        notification.text = errMsg;
        this.sharedDataService.pushNotification(notification);
      }
    );
  }

  dateInputClick(event,picker): void {
    event.currentTarget.blur()
    event.stopImmediatePropagation();
    picker.open();
  }

}
